import type { FC } from "react";
import { mergeClasses } from "@huub-web/utils";

import { Markdown } from "../Markdown/Markdown";
import { Body, type BodyProps } from "../Body/Body";
import type { ResponseVariant } from "../../types";
import { containerStyle } from "./ResponseBody.css";
import type { TypographyBodyVariant } from "../../theme";

export type ResponseBodyProps = {
  content: string;
  isStreaming?: boolean;
  variant?: ResponseVariant;
};

/**
 * ResponseBody component is a component that displays the content of a chat message.
 */
export const ResponseBody: FC<ResponseBodyProps> = ({
  variant = "hub",
  isStreaming = false,
  content,
}) => {
  const bodyVariant: TypographyBodyVariant = (() => {
    if (variant === "history") {
      return "bodyM";
    }
    if (variant === "sideContent") {
      return "bodyM";
    }
    return "chatMessageM";
  })();

  const bodyAlign: BodyProps["align"] = (() => {
    if (variant === "history" || variant === "sideContent") {
      return "left";
    }
    return "center";
  })();

  return (
    <Body
      className={mergeClasses(
        containerStyle({ variant }),
        isStreaming ? "--streaming" : undefined,
      )}
      align={bodyAlign}
      variant={bodyVariant}
      chatMode
    >
      <Markdown content={content} variant={variant} />
    </Body>
  );
};
